import * as React from 'react'

import { IconComponent } from '../../../../types'

export const FuseCircle: IconComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <rect width="128" height="128" fill="url(#paint0_linear_101_1987)" rx="64"></rect>
    <mask
      id="mask0_101_1987"
      style={{ maskType: 'alpha' }}
      width="80"
      height="32"
      x="24"
      y="74"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M24.44 74.794h79.35v30.578H24.44V74.794z"></path>
    </mask>
    <g mask="url(#mask0_101_1987)">
      <path
        fill="url(#paint1_linear_101_1987)"
        fillRule="evenodd"
        d="M64.038 90.357c-2.796 0-5.394-.591-7.515-1.71L33.685 76.593l-6.843 4.151c-3.252 1.972-3.196 4.996.127 6.75l31.586 16.67c1.534.809 3.495 1.208 5.483 1.208 2.32 0 4.675-.543 6.428-1.605l30.921-18.757c3.253-1.973 3.196-4.997-.126-6.75l-6.567-3.467-21.97 13.328c-2.377 1.44-5.462 2.235-8.686 2.235z"
        clipRule="evenodd"
      ></path>
    </g>
    <path
      fill="url(#paint2_linear_101_1987)"
      fillRule="evenodd"
      d="M101.464 58.304l-5.483-2.937-12.769 7.859-2.192 1.348-2.191 1.35-5.977 3.678c-2.384 1.468-5.478 2.276-8.71 2.276-2.803 0-5.408-.602-7.534-1.74l-6.849-3.668-2.266-1.212-2.267-1.214-12.618-6.759-5.76 3.546c-3.26 2.007-3.205 5.082.127 6.866l6.585 3.526 2.267 1.214 2.265 1.214 20.553 11.006c1.537.823 3.505 1.227 5.497 1.227 2.326 0 4.688-.55 6.444-1.631l19.76-12.162 2.192-1.349 2.191-1.349 6.862-4.222c3.261-2.007 3.204-5.083-.127-6.867z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint3_linear_101_1987)"
      fillRule="evenodd"
      d="M101.464 40.312l-31.67-16.664c-1.538-.81-3.504-1.207-5.498-1.207-2.326 0-4.688.542-6.444 1.604l-31.003 18.75c-3.262 1.972-3.206 4.994.126 6.747l5.483 2.885 2.267 1.193 2.266 1.193 12.618 6.64 2.267 1.191 2.267 1.194 4.502 2.37c1.537.808 3.505 1.205 5.497 1.205 2.326 0 4.688-.542 6.444-1.604l3.71-2.243 2.192-1.326 2.19-1.325 12.77-7.722 2.191-1.325 2.191-1.326 5.761-3.483c3.261-1.972 3.204-4.994-.127-6.747z"
      clipRule="evenodd"
    ></path>
    <defs>
      <linearGradient id="paint0_linear_101_1987" x1="64" x2="64" y1="0" y2="128" gradientUnits="userSpaceOnUse">
        <stop stopColor="#5F5F5F"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_101_1987"
        x1="64.115"
        x2="64.115"
        y1="25.108"
        y2="105.373"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3F9BA"></stop>
        <stop offset="1" stopColor="#F6FB8C"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_101_1987"
        x1="64.219"
        x2="64.219"
        y1="25.17"
        y2="103.527"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B1FFBF"></stop>
        <stop offset="1" stopColor="#FFF16D"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_101_1987"
        x1="64.219"
        x2="64.219"
        y1="22.441"
        y2="103.752"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3F9BA"></stop>
        <stop offset="1" stopColor="#F6FB8C"></stop>
      </linearGradient>
    </defs>
  </svg>
)
